module.exports = __webpack_public_path__ + "img/step06_a_stand_basic_left_bottom_cross.bc91bb8b.png";